import React from 'react';
import classnames from 'classnames';
import s from './NewContentIndicator.scss';
var NewContentIndicator = function (_a) {
    var className = _a.className, bottomCircleClassName = _a.bottomCircleClassName;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(s['bottom-circle'], bottomCircleClassName) },
            React.createElement("div", { className: s['top-circle'] }))));
};
NewContentIndicator.displayName = 'NewContentIndicator';
export default NewContentIndicator;
//# sourceMappingURL=NewContentIndicator.js.map